
export default function removeURLParameters(url, parameters) {
  var urlparts = url.split('?');
  if (urlparts.length >= 2) {
    var params = parameters;
    if (!Array.isArray(parameters)) {
      params = [];
      params.push(parameters);
    }
    var pars = urlparts[1].split(/[&;]/g);
    for (var i = 0; i < params.length; i += 1) {
      var parameter = params[i];
      var prefix = encodeURIComponent(parameter) + '=';
      for (var j = pars.length - 1; j >= 0; j -= 1) {
        var str = pars[j];
        if (str && str.toLowerCase().startsWith(prefix.toLowerCase())) {
          pars.splice(j, 1);
        }
      }
    }
    return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
  }
  return url;
}
